import React from 'react';
import SectionWrapper from './SectionWrapper';
import { useLanguage } from '../../i18n/LanguageContext';

export default function ProjectDetailShimmer() {
  const { t } = useLanguage();

  return (
    <SectionWrapper id="project-detail">
      <div className="project-detail-card mx-auto">

        {/* Title */}
        <div className="shimmer-line title-shimmer mb-3" />

        {/* Description */}
        <div className="shimmer-line desc-shimmer mb-4" />

        {/* Main Image Placeholder */}
        <div className="shimmer-rect main-image-shimmer mb-5" />

        {/* Tech Badges */}
        <div className="d-flex flex-wrap gap-2 mb-5">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="shimmer-badge" />
          ))}
        </div>

        {/* Buttons */}
        <div className="d-flex gap-3 mb-5">
          <div className="shimmer-btn" />
          <div className="shimmer-btn small" />
        </div>

        {/* Screenshots Grid */}
        <h5 className="mb-3">{t('projectDetail.screenshots')}</h5>
        <div className="row g-4 mb-5">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="col-12 col-md-6">
              <div className="shimmer-rect screenshot-shimmer" />
            </div>
          ))}
        </div>

        {/* Back Link */}
        <div className="shimmer-line backlink-shimmer" />

      </div>
    </SectionWrapper>
  );
}
